import React from 'react';
import type { TeamMember } from '../types';
import OptimizedImage from './OptimizedImage';

interface TeamMemberCardProps {
    member: TeamMember;
    onSelect: () => void;
}

const TeamMemberCard: React.FC<TeamMemberCardProps> = ({ member, onSelect }) => {
    return (
        <button
            onClick={onSelect}
            className="text-center group flex flex-col items-center"
            aria-label={`View details for ${member.name}`}
        >
            <div className="relative w-40 h-40 md:w-48 md:h-48 mx-auto mb-4 rounded-full overflow-hidden shadow-lg group-hover:shadow-xl transition-all duration-300">
                <OptimizedImage
                    src={member.imageUrl}
                    size={800}
                    alt={member.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-all duration-300"
                    fallbackSrc={`https://ui-avatars.com/api/?name=${encodeURIComponent(member.name)}&background=e5e7eb&color=4b5563&size=800`}
                />
            </div>
            <h3 className="text-xl font-bold font-heading text-brand-dark group-hover:text-gray-600 transition-colors">{member.name}</h3>
            <p className="text-md text-gray-700 uppercase tracking-wider font-header mt-1 text-balance">{member.role}</p>
        </button>
    );
};

export default TeamMemberCard;